module.exports = __webpack_public_path__ + "static/media/maple-dot.bd59a8ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maple-dot.svg
// module id = 864
// module chunks = 1